import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const actionType = {
	SetMenu: '[MENU] SET_MENU',
};

export const initialMenu = {};

const initialState = {
	menu: {
		data: {
			aside: {
				items: [
					
				],
			},
		},
	},
};

export const reducer = persistReducer(
	{ storage, key: 'menu', whitelist: ['menu'] },
	(state = initialState, action) => {
		switch (action.type) {
			case actionType.SetMenu:
				return { ...state, menu: action.payload };

			default:
				return state;
		}
	}
);

export const actions = {
	setMenu: (data) => ({
		type: actionType.SetMenu,
		payload: { data },
	}),
};
